import { Nullish } from '../data/Nullish.ts';

export function classNames(...classes: Nullish<string>[]) {
  return classes.filter(Boolean).join(' ');
}
